<div class="root mb-3 mb-md-5">
  <ng-content></ng-content>
</div>
